import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import classNames from 'classnames';

import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import CustomDialog from './CustomDialog';
import { FormattedMessageWrappedInSpan } from '../../misc';

const PENDING = 'Pending';
const CANCEL = 'Cancel';
const FAILURE = 'Failure';
const ERROR = 'Error';

class WorldpayNotificationDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      checkboxIsSelected: false,
    };

    this.handleCheckboxChanged = this.handleCheckboxChanged.bind(this);
  }

  handleCheckboxChanged() {
    this.setState(prevState => ({ checkboxIsSelected: !prevState.checkboxIsSelected }));
  }

  render() {
    const { open, onRequestClose, path, intl } = this.props;
    const { checkboxIsSelected } = this.state;
    const acceptButtonDisabled = path === PENDING ? false : !checkboxIsSelected;

    return (
      <CustomDialog
        open={open}
        onRequestClose={onRequestClose}
        modal={!checkboxIsSelected}
      >
        <div className="notification-container">
          <div className="notification-body">
            <h1>
              {path === CANCEL && (
                <FormattedMessageWrappedInSpan
                  id="worldpayNotificationDialog.canceltitle"
                  defaultMessage="Payment canceled"
                />
              )}
              {path === FAILURE && (
                <FormattedMessageWrappedInSpan
                  id="worldpayNotificationDialog.failuretitle"
                  defaultMessage="Declined payment"
                />
              )}
              {path === ERROR && (
                <FormattedMessageWrappedInSpan
                  id="worldpayNotificationDialog.errortitle"
                  defaultMessage="Payment error"
                />
              )}
            </h1>
            <div className="mb-30">
              {path === PENDING && (
                <FormattedMessageWrappedInSpan
                  id="worldpayNotificationDialog.pendingMessage"
                  defaultMessage="Thank you for your order. Your data will be checked. As soon as the payment has been registered, your photos will be available for download and we will inform you by e-mail.{br}Have fun with your photos!"
                  values={{ br: <br /> }}
                />
              )}
              {path === CANCEL && (
                <FormattedMessageWrappedInSpan
                  id="worldpayNotificationDialog.cancelMessage"
                  defaultMessage="You have canceled the payment process. Please choose another payment method or try again."
                />
              )}
              {path === FAILURE && (
                <FormattedMessageWrappedInSpan
                  id="worldpayNotificationDialog.failureMessage"
                  defaultMessage="Unfortunately, your payment was declined.{br}Please choose a different credit card or payment method."
                  values={{ br: <br /> }}
                />
              )}
              {path === ERROR && (
                <FormattedMessageWrappedInSpan
                  id="worldpayNotificationDialog.errorMessage"
                  defaultMessage="Unfortunately, payment via Worldpay is currently not possible. Please choose another payment method."
                />
              )}
            </div>
            {(path === ERROR || path === FAILURE || path === CANCEL) && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checkboxIsSelected}
                    onChange={this.handleCheckboxChanged}
                  />
                }
                label={intl.formatMessage(translations.checkboxLabel)}
              />
            )}
          </div>
          <div className="notification-action">
            <button
              className={classNames('accept', { disabled: acceptButtonDisabled })}
              onClick={onRequestClose}
              disabled={acceptButtonDisabled}
            >
              <FormattedMessageWrappedInSpan
                id="worldpayNotificationDialog.acceptButton"
                defaultMessage="OK"
              />
            </button>
          </div>
        </div>
      </CustomDialog>
    );
  }
}

const translations = defineMessages({
  checkboxLabel: {
    id: 'worldpayNotificationDialog.checkboxLabel',
    defaultMessage: 'I have read the informations',
  },
});

WorldpayNotificationDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  intl: PropTypes.object,
  onRequestClose: PropTypes.func,
  path: PropTypes.oneOf([CANCEL, FAILURE, ERROR, PENDING]),
};

export default injectIntl(WorldpayNotificationDialog);
export { WorldpayNotificationDialog };
